import { updateLazy } from "Functions/lazy";
import "Layouts/default";
import "Ui/slider";

document.addEventListener("DOMContentLoaded", function () {
    updateLazy();
});
